import { Alert, Box, Snackbar } from '@mui/material';
import React from 'react'

type Prop =
    {
        message: string,
        open: boolean,
        onClose: () => void,
        alertType: number
    }
const CustomSnackbar: React.FC<Prop> = ({
    message,
    open,
    onClose,
    alertType
}) => {
    return (
        <>
            <Box sx={{ width: 500 }}>
                <Snackbar
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    open={open}
                    onClose={onClose}
                    key={"bottomcenter"}
                    autoHideDuration={3000}
                >
                    <Alert severity={alertType == 4 ? "success" : alertType == 7 ? "info" : alertType == 3 ? "error" : "info"} onClose={onClose} >{message}</Alert>
                </Snackbar>
            </Box>
        </>
    )
}
export default CustomSnackbar;